module.exports = __webpack_public_path__ + "img/slide-02.9dcdc77a.jpg";